import Vue from 'vue'

Vue.filter('absenceusageType', function (value) {
  if (!value) return ''

  switch (value) {
    case 'ABSENCE':
      return 'Abwesenheit'

    case 'ALLOCATION':
      return 'Kontingent'

    case 'ALLOCATION_EXPIRY':
      return 'Kontingent abgelaufen'

    default:
      return value
  }
})
